import React, { useState, useEffect } from 'react';
import API from '../../../API';
import store from '../../../store';
import { Row, Button } from 'reactstrap';
import { T, TraksConsumer } from '../../../traks';
import { default_currency } from '../../../Site';
import { ConnectedCheckout } from '../Checkout/Checkout';
import { OrderOverview } from '../Order/OrderOverview';
import { PaymentFrame } from '../Payment/PaymentFrame';
import { Cart } from './Cart';
import { ThankYou } from '../ThankYou/ThankYou';
import { PaymentError } from '../Payment/PaymentError';


export const CartWrapper = () => {
    const [show, setShow] = useState(false);
    const [cart, setCart] = useState({});
    const [game, setGame] = useState(null);
    const [orderId, setOrderId] = useState('');
    const [view, setView] = useState('order');
    const [orderDetails, setOrderDetails] = useState({});
    const [preDefinedMonths, setPreDefinedMonths] = useState(null);
    const vatRate = 25;

    const handlePaymentComplete = (order) => {
      API.post('/a/update_payment', {
        orderId: orderId.replace(/"/g, ''),
        orderStatus: order.data.message
      }, (response, status) => {
        if (status !== 200) {
            return;
        }

        setView('thankyou');
      });
    }

    const handlePaymentFailed = () => {
        API.post('/a/update_payment', {
          orderId: orderId.replace(/"/g, ''),
          orderStatus: 'Cancelled'
        }, (response, status) => {
          if (status !== 200) {
              return;
          }

          setView('error');
      });
    }

    store.subscribe(() => {
        const state = store.getState();
        if (!!state.show_cart) {
            setShow(true);
        } else {
            setShow(false);
        }

        if (state.show_cart_game_upgrade) {
            setGame(state.show_cart_game_upgrade.game_id);
        }
    });

    useEffect(() => {
        const state = localStorage.getItem('cart');
        if (state) {
            const cartState = JSON.parse(state);
            setCart(cartState);
        }

        const gameState = localStorage.getItem('cart-game');
        if (gameState) {
            setGame(gameState);
        }
    }, [])

    useEffect(() => {
        const upgradeMonths = Number(localStorage.getItem("upgrade_months"));
        if (upgradeMonths) {
            setPreDefinedMonths(upgradeMonths);
            localStorage.removeItem("upgrade_months");
        }
    })

    useEffect(() => {
        localStorage.setItem('cart', JSON.stringify(cart));
    }, [cart])
    
    const close = () => {
        store.dispatch_value('show_cart', false);
        setView('order');
    }

    const setHeaderBreadcrumb = () => {
        const steps = ['order', 'cart', 'checkout', 'payment', 'thankyou'];
        const labels = {
            order: <T>Order</T>,
            cart: <T>Your Cart</T>,
            checkout: <T>Checkout</T>,
            payment: <T>Payment</T>,
            thankyou: <T>Thank You</T>
        };

        return (
            <Row className="cart-breadcrumb">
                {steps.map((step, index) => {
                    const isActive = step === view;
                    return (
                        <span key={step} className={`cart-breadcrumb-step ${isActive ? 'active' : ''}`}>
                            {labels[step]}
                            {index < steps.length - 1 && <span className="cart-breadcrumb-separator"> &gt; </span>}
                        </span>
                    );
                })}
            </Row>
        )
    }

    const displayViewContent = () => {
        if (view === 'cart') {
          return <Cart cart={cart} setCart={setCart} setView={setView} defaultCurrency={default_currency} vatRate={vatRate} />;
        } else if (view === 'checkout') {
          return <ConnectedCheckout cart={cart} setCart={setCart} setView={setView} setOrderId={setOrderId} game={game} defaultCurrency={default_currency} setOrderDetails={setOrderDetails} vatRate={vatRate} />;
        } else if (view === 'order') {
          return <TraksConsumer><OrderOverview cart={cart} setCart={setCart} setView={setView} game={game} setGame={setGame} vatRate={vatRate} preDefinedMonths={preDefinedMonths} /></TraksConsumer>;
        } else if (view === 'payment') {
          return <PaymentFrame orderId={orderId} onComplete={(data) => handlePaymentComplete(data)} setView={setView} onError={() => handlePaymentFailed()} />;
        } else if (view === 'thankyou') {
          return <ThankYou cart={cart} setCart={setCart} game={game} setGame={setGame} orderDetails={orderDetails} />;
        } else if (view === 'error') {
          return <PaymentError setView={setView} />;
        }
    }

    return (
        <div>
            <div id='cart' className={show === false ? 'hidden' : ''}>
                <div className='cart-container'>
                    <header>
                        <div className='cart-header-inner'>
                            {setHeaderBreadcrumb()}
                            <div className='cart-header-button'>
                                <Button color="unknown" onClick={close}><img src='/gfx/remove-portfolio-icon-1.svg' alt='Close cart icon' /></Button>
                            </div>
                        </div>
                    </header>
                    {show === true ? displayViewContent() : null}
                </div>
            </div>
            <div className={`modal-backdrop fade ${show === true ? 'show' : ''} ${show === false ? 'd-none' : ''}`} onClick={close}></div>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/c/PremiumKeys/Cart/CartWrapper.js